<template>
  <div class="tw-flex tw-flex-row tw-gap-4 tw-justify-center tw-items-baseline">
    <a :class="previousClasses" @click="previousPage">
      {{ I18n.t('common.pagination.previous') }}
    </a>
    <a v-if="startingAroundPage > 1" @click="changePage(1)">1</a>
    <span v-if="startingAroundPage > 2">&hellip;</span>
    <template v-if="startingAroundPage < currentPage">
      <a
        v-for="i in currentPage - startingAroundPage"
        :key="i + startingAroundPage - 1"
        @click="changePage(i + startingAroundPage - 1)"
      >
        {{ i + startingAroundPage - 1 }}
      </a>
    </template>
    <span>{{ currentPage }}</span>
    <template v-if="endingAroundPage > currentPage">
      <a
        v-for="i in endingAroundPage - currentPage"
        :key="i + currentPage"
        @click="changePage(i + currentPage)"
      >
        {{ i + currentPage }}
      </a>
    </template>
    <span v-if="endingAroundPage < totalPages - 1">&hellip;</span>
    <a v-if="endingAroundPage < totalPages" @click="changePage(totalPages)">
      {{ totalPages }}
    </a>
    <a :class="nextClasses" @click="nextPage">
      {{ I18n.t('common.pagination.next') }}
    </a>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import useI18n from '@app/shared/vue/composables/use-I18n'

const I18n = useI18n()

interface Props {
  currentPage: number
  totalPages: number
}

const props = defineProps<Props>()
const emit = defineEmits<{ 'change-page': [number] }>()

const previousClasses = computed(() =>
  props.currentPage === 1
    ? [
        'tw-cursor-default',
        'tw-text-sf-gray-lighter',
        'hover:tw-no-underline',
        'hover:tw-text-sf-gray-lighter',
      ]
    : []
)

const nextClasses = computed(() =>
  props.currentPage === props.totalPages
    ? [
        'tw-cursor-default',
        'tw-text-sf-gray-lighter',
        'hover:tw-no-underline',
        'hover:tw-text-sf-gray-lighter',
      ]
    : []
)

const startingAroundPage = computed(() => Math.max(1, props.currentPage - 2))
const endingAroundPage = computed(() =>
  Math.min(props.totalPages, props.currentPage + 2)
)

function changePage(page: number) {
  emit('change-page', page)
}

function previousPage() {
  if (props.currentPage > 1) {
    changePage(props.currentPage - 1)
  }
}

function nextPage() {
  if (props.currentPage < props.totalPages) {
    changePage(props.currentPage + 1)
  }
}
</script>
